import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import Button, { BUTTON_HEIGHT_32 } from '../../../Button'
import { useWidgetContext } from '../../Widget.hooks'
import { QA_NAME_PROFILE_INFO_EXPAND_SECTIONS_BUTTON } from '../ProfileInfoWidget.constants'

import ChevronCollapseIcon from '../../../../icons/chevron-collapse.svg'
import ChevronExpandIcon from '../../../../icons/chevron-expand.svg'

function ProfileInfoWidgetExpandSectionsButton({
  isExpanded,
  onToggle,
  ...restProps
}) {
  const { t } = useTranslation()

  const {
    handleToggleExpanded,
    isEditMode,
    isExpanded: isWidgetExpanded,
  } = useWidgetContext()

  function handleClick(event) {
    if (!isWidgetExpanded) {
      handleToggleExpanded(event)
    }

    onToggle(event)
  }

  return isEditMode ? null : (
    <Button.Outlined
      {...restProps}
      isGrey
      beforeIconProps={{
        Icon: isExpanded ? ChevronCollapseIcon : ChevronExpandIcon,
      }}
      height={BUTTON_HEIGHT_32}
      isActive={isExpanded}
      qaName={QA_NAME_PROFILE_INFO_EXPAND_SECTIONS_BUTTON}
      tooltip={t(
        isExpanded
          ? 'Widget.InfoShowFilledFieldsTooltipKey'
          : 'Widget.InfoShowAllFieldsTooltipKey'
      )}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
      onClick={handleClick}
    />
  )
}

export default ProfileInfoWidgetExpandSectionsButton
